import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
export default () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const handleCardIconClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker?.() || inputRef.current.focus(); // .showPicker() for modern browsers
    }
  };
  return {
    inputRef,
    handleCardIconClick,
    isPasswordVisible,
    togglePasswordVisibility,
    navigate,
  };
};
